import React from "react";
import { TextField, Button, Stack } from "@mui/material";
import SendIcon from '@mui/icons-material/Send';
function UserInput({ value, onChange, onSend, sendDisabled }) {
    return <Stack
        direction="row"
        spacing={2}
        p={1}
    >
        <TextField
            multiline
            maxRows={4}
            fullWidth
            variant="outlined"
            placeholder="Type your message..."
            value={value}
            onKeyDown={(event) => {
                if (event.key === 'Enter' && !event.shiftKey && !sendDisabled) {
                    event.preventDefault();
                    onSend();
                }
            }}
            onChange={(event) => {
                onChange(event.target.value);
            }}
        />
        <Button
            variant="contained"
            disabled={sendDisabled}
            endIcon={<SendIcon />}
            onClick={() => {
                onSend();
            }}>
            Send
        </Button>
    </Stack>
}

export default UserInput;